(function () {
  "use strict";

  const MEDIA_SELECTOR = [
    'a.ga-hoop-card__media[href*="/products/"]',
    'a.ga-two-product__media[href*="/products/"]',
    'a.ga-signature-product__media[href*="/products/"]',
    'a.ga-cuff-product__media[href*="/products/"]'
  ].join(",");

  const IMAGE_SELECTOR = [
    ".ga-hoop-card__image",
    ".ga-two-product__image",
    ".ga-signature-product__image",
    ".ga-cuff-product__image"
  ].join(",");

  const PLACEHOLDER_SELECTOR = [
    ".ga-hoop-card__placeholder",
    ".ga-two-product__placeholder",
    ".ga-signature-product__placeholder",
    ".ga-cuff-product__placeholder"
  ].join(",");

  const productCache = new Map();

  function getHandle(link) {
    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/i);

      return match ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      return "";
    }
  }

  function createImageUrl(source, width) {
    if (!source) {
      return "";
    }

    let imageSource = source;

    if (imageSource.indexOf("//") === 0) {
      imageSource = "https:" + imageSource;
    }

    try {
      const url = new URL(imageSource, window.location.origin);
      url.searchParams.set("width", String(width));

      return url.toString();
    } catch (error) {
      return imageSource;
    }
  }

  function getProduct(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    const request = fetch(
      root + "products/" + encodeURIComponent(handle) + ".js",
      {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Product request failed: " +
          handle +
          " — " +
          response.status
        );
      }

      return response.json();
    });

    productCache.set(handle, request);

    return request;
  }

  function revealImage(link, image, placeholder) {
    image.classList.add("is-loaded");

    image.style.setProperty("opacity", "1", "important");
    image.style.setProperty("visibility", "visible", "important");
    image.style.setProperty("display", "block", "important");

    if (placeholder) {
      placeholder.style.display = "none";
    }

    link.dataset.gaProductImageStatus = "loaded";
  }

  function showError(link, placeholder, handle, error) {
    link.dataset.gaProductImageStatus = "error";

    if (placeholder) {
      placeholder.textContent = "View product";
      placeholder.style.display = "flex";
    }

    console.error(
      "[GA product image loader]",
      handle,
      error
    );
  }

  async function loadProductCard(link) {
    const status = link.dataset.gaProductImageStatus;

    if (status === "loading" || status === "loaded") {
      return;
    }

    const handle = getHandle(link);
    const image = link.querySelector(IMAGE_SELECTOR);
    const placeholder = link.querySelector(
      PLACEHOLDER_SELECTOR
    );

    if (!handle || !image) {
      return;
    }

    link.dataset.gaProductImageStatus = "loading";

    try {
      const product = await getProduct(handle);

      const source =
        product.featured_image ||
        (
          Array.isArray(product.images) &&
          product.images.length
            ? product.images[0]
            : ""
        );

      if (!source) {
        throw new Error("No product image found.");
      }

      image.loading = "lazy";
      image.decoding = "async";

      image.srcset = [
        createImageUrl(source, 480) + " 480w",
        createImageUrl(source, 720) + " 720w",
        createImageUrl(source, 1000) + " 1000w",
        createImageUrl(source, 1400) + " 1400w"
      ].join(", ");

      image.sizes =
        "(max-width: 750px) 86vw, " +
        "(max-width: 1050px) 45vw, " +
        "33vw";

      image.addEventListener(
        "load",
        function () {
          revealImage(link, image, placeholder);
        },
        { once: true }
      );

      image.addEventListener(
        "error",
        function (event) {
          showError(
            link,
            placeholder,
            handle,
            event
          );
        },
        { once: true }
      );

      image.src = createImageUrl(source, 1000);

      if (image.complete && image.naturalWidth > 0) {
        revealImage(link, image, placeholder);
      }
    } catch (error) {
      showError(link, placeholder, handle, error);
    }
  }

  function scanForProductCards(root) {
    const container =
      root && typeof root.querySelectorAll === "function"
        ? root
        : document;

    /*
     * Include the root itself when it is a matching product link.
     */
    if (
      container.matches &&
      container.matches(MEDIA_SELECTOR)
    ) {
      loadProductCard(container);
    }

    container
      .querySelectorAll(MEDIA_SELECTOR)
      .forEach(function (link) {
        loadProductCard(link);
      });
  }

  function initialiseRail() {
    const rail = document.querySelector(
      "#ga-one-piercing-rail"
    );

    const buttons = document.querySelectorAll(
      ".ga-one-piercing__controls " +
      ".ga-one-piercing__control"
    );

    if (!rail || buttons.length < 2) {
      return;
    }

    function move(direction) {
      const card = rail.querySelector(".ga-hoop-card");

      const distance = card
        ? card.getBoundingClientRect().width + 18
        : rail.clientWidth * 0.8;

      rail.scrollBy({
        left: direction * distance,
        behavior: "smooth"
      });
    }

    if (buttons[0].dataset.gaBound !== "true") {
      buttons[0].dataset.gaBound = "true";
      buttons[0].removeAttribute("tabindex");
      buttons[0].setAttribute(
        "aria-label",
        "View previous earrings"
      );

      buttons[0].addEventListener("click", function () {
        move(-1);
      });
    }

    if (buttons[1].dataset.gaBound !== "true") {
      buttons[1].dataset.gaBound = "true";
      buttons[1].removeAttribute("tabindex");
      buttons[1].setAttribute(
        "aria-label",
        "View next earrings"
      );

      buttons[1].addEventListener("click", function () {
        move(1);
      });
    }
  }

  function initialise() {
    scanForProductCards(document);
    initialiseRail();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialise,
      { once: true }
    );
  } else {
    initialise();
  }

  /*
   * Retry because Shopify theme sections or article content can appear
   * slightly after the initial page scripts execute.
   */
  window.setTimeout(initialise, 500);
  window.setTimeout(initialise, 1500);
  window.setTimeout(initialise, 3000);
  window.setTimeout(initialise, 6000);

  /*
   * Detect product cards inserted after the page initially loads.
   */
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          scanForProductCards(node);
        }
      });
    });
  });

  function startObserver() {
    if (!document.body) {
      return;
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener(
      "DOMContentLoaded",
      startObserver,
      { once: true }
    );
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      scanForProductCards(event.target);
      initialiseRail();
    }
  );
})();